export default __webpack_public_path__ + "static/media/gallery_06.7e3030c3.jpg";